<template>
  <v-row id="grid-layout-container">
    <div id="dashboard-greeting">
      <h2>Hello {{ user.firstName }} {{ user.lastName }}</h2>
    </div>
      <grid-layout
          :layout.sync="layout"
          :colNum="12"
          :row-height="30"
          :colWidth="30"
          :maxRows="50"
          :responsive="true"
          :is-draggable="false"
          :is-resizable="false"
          :vertical-compact="true"
          :use-css-transforms="true"
          ref="grid"
          @layout-ready="layoutReady"
      >
        <grid-item :key="item.i" v-for="item in layout"
                   :static="item.static"
                   :x="item.x"
                   :y="item.y"
                   :w="item.w"
                   :h="item.h"
                   :i="item.i"
        >
            <component :is="item.component"></component>
        </grid-item>
      </grid-layout>
  </v-row>

</template>

<script>

import { GridLayout, GridItem } from 'vue-grid-layout'
import Header from '../header/Header'
import Greeting from './Greeting'

import SalesOrderOverlay from '../overlays_OLD/sales_orders/SalesOrderOverlay'
import ClientCode from '../clients/ClientCode'
import ClientOverlay from '../overlays_OLD/clients/ClientOverlay'

import ActionItems from './widgets/ActionItems'
import SalesPipeline from './widgets/SalesPipeline'
import BillingAndSales from './widgets/BillingAndSales'
import PastDueAtRisk from './widgets/PastDueAtRisk'
import OffToday from './widgets/OffToday'
import HotOrders from './widgets/HotOrders'
import PastDueByOffice from './widgets/PastDueByOffice'
import DropShips from './widgets/DropShips'
import CreditHolds from './widgets/CreditHolds'

import Vue from 'vue'

export default {
  data () {
    return {
      searchTerm: '',
      searchType: 'SO',
      searchTypes: [
        'SO',
        'Client',
        'PO',
        'Quote',
        'Item'
      ],
      user: this.$session.get('user')
    }
  },
  components: {
    'app-header': Header,
    Greeting,
    ClientCode,
    GridLayout,
    GridItem,
    ActionItems,
    SalesPipeline,
    BillingAndSales,
    PastDueAtRisk,
    OffToday,
    HotOrders,
    PastDueByOffice,
    DropShips,
    CreditHolds
  },
  methods: {
    submitSearch () {
      // Get the search function by the search type.
      const funcs = {
        so: this.searchSO,
        client: this.searchClient
      }
      const func = funcs[this.searchType]
      func()
    },
    searchSO () {
      const sono = this.searchTerm.trim()
      const SalesOrderOverlayClass = Vue.extend(SalesOrderOverlay)
      const salesOrderOverlay = new SalesOrderOverlayClass({
        propsData: {sono: sono}
      })
      salesOrderOverlay.$mount()
      const app = document.getElementById('app')
      app.appendChild(salesOrderOverlay.$el)
    },
    searchClient () {
      const custno = this.searchTerm.trim()
      const ClientOverlayClass = Vue.extend(ClientOverlay)
      const clientOverlay = new ClientOverlayClass({
        propsData: {custno: custno}
      })
      clientOverlay.$mount()
      const app = document.getElementById('app')
      app.appendChild(clientOverlay.$el)
    },
    layoutReady () {
      if (document.body.clientWidth <= 480) {
        window.dispatchEvent(new Event('resize'));
      }
    }
  },
  computed: {
    layout: {
      get () {return this.$store.getters['dashboard_configuration/getLayout']},
      set (value) {this.$store.commit('dashboard_configuration/setLayout', value)}
    }
  },
  beforeMount () {
    this.$store.dispatch('dashboard_configuration/fetchUserDashboardConfiguration', this.$session.get('loginId'))
  }
}
</script>

<style scoped>
#grid-layout-container {
  width: 100%;
  height: 100%;
}
.grid-item-content-container {
  width: 100%;
  height: 100%;
}
.vue-grid-layout {
  height: 100%;
  width: 100%;
}
#dashboard-greeting {
  margin-left: 1em;
}
</style>
